module.exports = __webpack_public_path__ + "media/images/bg-get-started-5e5b4e94.png";